import { create } from 'zustand';
import { message } from 'antd';
import apiCore from '../utils/api-core';

const useModuleGroupsListStore = create((set, get) => ({
    moduleGroups: [],
    loading: false,
    total: 0,
    
    queryState: {
        page: 1,
        pageSize: 25,
        search: '',
        sortField: 'created_at',
        sortOrder: 'desc',
    },

    setQueryState: (newState) => set((state) => ({
        queryState: typeof newState === 'function' ? newState(state.queryState) : { ...state.queryState, ...newState }
    })),

    fetchModuleGroups: async () => {
        const { queryState } = get();
        set({ loading: true });
        try {
            const res = await apiCore.get('/api/v3/module-group', {
                params: {
                    page: queryState.page,
                    limit: queryState.pageSize,
                    search: queryState.search,
                    sort: queryState.sortField,
                    order: queryState.sortOrder
                }
            });
            const data = res.data || res;
            set({
                moduleGroups: data.rows || [],
                total: data.total || 0,
                loading: false,
            });
        } catch (error) {
            console.error('Failed to fetch module groups:', error);
            set({ loading: false });
            message.error('Failed to load module groups');
        }
    },

    createModuleGroup: async (data) => {
        try {
            const res = await apiCore.post('/api/v3/module-group', data);
            message.success('Module group created successfully');
            return res.data || res;
        } catch (error) {
            console.error('Failed to create module group:', error);
            message.error('Failed to create module group');
            throw error;
        }
    },

    duplicateModuleGroup: async (id, data) => {
        try {
            const res = await apiCore.post(`/api/v3/module-group/${id}/duplicate`, data);
            message.success('Module group duplicated successfully');
            return res.data || res;
        } catch (error) {
            console.error('Failed to duplicate module group:', error);
            message.error('Failed to duplicate module group');
            throw error;
        }
    },

    deleteModuleGroup: async (id) => {
        try {
            await apiCore.delete(`/api/v3/module-group/${id}`);
            message.success('Module group deleted successfully');
            await get().fetchModuleGroups();
        } catch (error) {
            console.error('Failed to delete module group:', error);
            message.error('Failed to delete module group');
            throw error;
        }
    },
}));

export default useModuleGroupsListStore;
